import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import "./index.scss"
import AnimatedLetters from '../AnimatedLetters'

import Loader from 'react-loaders'
import portfolioData from '../../data/portfolio.json'

const Portfolio = () => {
    const navigate = useNavigate();
    const [letterClass, setLetterClass] = useState('text-animate');
    console.log(portfolioData)

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover');

        }, 3000);

        return () => {
            clearTimeout(timer)
        }
    });

    const renderPortfolio = (portfolio) => {
        return (
            <div className="images-container">
                {
                    portfolio.map((port, idx) => {
                        return <PortfolioItem key={idx} port={port} />;
                    })
                }
            </div>
        );
    }

    return (
        <>
            <div className="container portfolio-page">
                <h1 className="page-title">
                    <AnimatedLetters
                        letterClass={letterClass}
                        strArray={"Portfolio".split("")}
                        idx={15}
                    />
                </h1>
                <div>{renderPortfolio(portfolioData.portfolio)}</div>

                <div className="web-portfolio-link" style={{ textAlign: 'center', marginTop: '40px', paddingBottom: '40px' }}>
                    <h3 style={{ color: '#fff', fontFamily: 'sans-serif', fontSize: '18px', marginBottom: '15px' }}>Looking for web development examples?</h3>
                    <button
                        className="flat-button"
                        onClick={() => navigate('/portfolio/web')}
                        style={{ float: 'none', display: 'block', margin: '20px auto' }}
                    >
                        VIEW WEB PORTFOLIO
                    </button>
                </div>

            </div>
            <Loader type="ball-scale-multiple" />
        </>
    );
}

const PortfolioItem = ({ port }) => {
    const navigate = useNavigate();
    const [currentIdx, setCurrentIdx] = useState(0);

    const nextImage = () => {
        setCurrentIdx((prev) => (prev + 1) % port.screenshots.length);
    };

    const prevImage = () => {
        setCurrentIdx((prev) => (prev - 1 + port.screenshots.length) % port.screenshots.length);
    };

    return (
        <div className="image-box">
            <div className="carousel-content">
                <button className="nav-btn prev" onClick={prevImage}>&#10094;</button>
                <img
                    src={port.screenshots[currentIdx]}
                    className="portfolio-image"
                    alt="portfolio" />
                <button className="nav-btn next" onClick={nextImage}>&#10095;</button>
            </div>
            <div className="content">
                <p className="title">{port.title}</p>
                <h4 className="description">{port.description}</h4>
                <button
                    className="btn"
                    onClick={() => navigate(`/portfolio/${port.slug}`)}>View</button>
            </div>
        </div>
    )
}

export default Portfolio














